"use client";
import * as u from "react";
import { useState as a, useEffect as m } from "react";
import { identifier as r } from "../utils/identifier.js";
import { useIsomorphicLayoutEffect as l } from "./use-isomorphic-layout-effect.js";
let e = !1;
const s = (t) => t ? `__c11n_${t}` : void 0, d = "useId", i = u[d], _ = (t) => {
  if (i !== void 0) {
    const c = i();
    return s(t ?? c);
  }
  const f = t ?? (e ? r() : null), [o, n] = a(f);
  return l(() => {
    o === null && n(r());
  }, []), m(() => {
    e === !1 && (e = !0);
  }, []), s(t ?? o ?? void 0);
};
export {
  _ as useId
};
//# sourceMappingURL=use-id.js.map
